import { Component } from '@angular/core';
import { NavigationComponent } from '../navigation.component';

@Component({
  selector: 'app-navigation-v2',
  templateUrl: './navigation-v2.component.html',
  styleUrls: ['./navigation-v2.component.scss'],
})
export class NavigationV2Component extends NavigationComponent {}
